var map = {
	"./hand-holding-seedling.png": "8a7f",
	"./intro.jpeg": "7e2a",
	"./logo--detailed.png": "7b06",
	"./logo--older.png": "3d2c",
	"./logo.png": "4ffd",
	"./new/GHS-02.jpg": "6aa7",
	"./new/ghs-01.png": "f859",
	"./new/ghs-03--1.png": "1ded",
	"./new/ghs-03.png": "7c4e",
	"./partners/devex.png": "653b",
	"./values/agility.png": "d3bd",
	"./values/commitment.png": "c487",
	"./values/diversity.png": "c970",
	"./values/mutual-respect.png": "d050",
	"./values/partnerships.png": "f585"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";